import { render, staticRenderFns } from "./publisDocument.vue?vue&type=template&id=252d6bf0&scoped=true&"
import script from "./publisDocument.vue?vue&type=script&lang=js&"
export * from "./publisDocument.vue?vue&type=script&lang=js&"
import style0 from "./publisDocument.vue?vue&type=style&index=0&id=252d6bf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252d6bf0",
  null
  
)

export default component.exports